import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollAnimation = () => {
  const location = useLocation();

  useEffect(() => {
    const elements = document.querySelectorAll(".animate-top");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            // observer.unobserve(entry.target); // 👈 stop observing
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      {
        threshold: 0.1, // 👈 increase
        rootMargin: "0px 0px 0px 0px", // 👈 buffer zone
      },
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [location.pathname]); // 👈 re-run on page change
};

export default useScrollAnimation;
